import dutchMessages from 'i18n/nl';
import englishMessages from 'i18n/en';
import frenchMessages from 'i18n/fr';
import germanMessages from 'i18n/de';
import italianMessages from 'i18n/it';
import spanishMessages from 'i18n/es';

export default {
    de: germanMessages,
    en: englishMessages,
    es: spanishMessages,
    fr: frenchMessages,
    it: italianMessages,
    nl: dutchMessages,
};



// WEBPACK FOOTER //
// ./src/i18n/index.js